import Component from 'Scripts/classes/Component'

export default class Intro extends Component {
  constructor({ container, elements }) {
    super({ container, elements })

    //Methods
    this.addEventListeners()
  }

  play() {
    this.elements.video.play()    
  }

  onSkip(e) {
    e.preventDefault()
    //
    this.elements.video.pause()
    //activate animation
    window.dispatchEvent(new CustomEvent('videoEnded'))      
  }

  unMute(e) {
    e.preventDefault()
    this.elements.video.muted = this.elements.video.muted ? false : true
    this.elements.unmute.remove()
  }

  destroy() {
    this.container.parentNode.removeChild(this.container)
  }

  addEventListeners() {
    this.elements.skip?.addEventListener('click', this.onSkip.bind(this))
    this.elements.unmute?.addEventListener('click', this.unMute.bind(this))
    this.elements.video?.addEventListener('ended', this.onSkip.bind(this))
  }

  removeEventListeners() {

  }
}